import { DoneOutline, Info } from "@mui/icons-material";
import { Divider } from "@mui/material";
import React from "react";
import * as msg from "utils/constants/messages";

const DiscardWarning = (props) => {
    return <>
        <div className="block-save">
            <Info style={{ color: "var(--hti-magenta)" }} />
            <div>{msg.data_discard}</div>
        </div>
        <Divider />

        <div
            className="icon-text"
            style={{ justifyContent: "center", marginTop: "10px" }}
        >
            <button
                className="apply-button"
                style={{ width: "70px" }}
                onClick={props.handleSubmit}
            >
                <p className="apply-button-text" >OK</p>
            </button>
            <button
                className="reset-button"
                style={{ width: "70px" }}
                onClick={props.handleCancel}
            >
                <p className="reset-button-text" >Cancel</p>
            </button>
        </div>
    </>
}

export default DiscardWarning;